<template>
  <v-menu
    v-model="menu"
    close-on-content-click
    location="bottom end"
    class="gr-overlay"
  >
    <template #activator="{ props }">
      <button
        type="button"
        class="gr-usermenu__trigger"
        v-bind="props"
        aria-label="Menu akun"
      >
        <img
          :src="$auth.user.avatarUrl || '/assets/images/avatar.png'"
          alt=""
          class="gr-usermenu__avatar"
          width="36"
          height="36"
        />
      </button>
    </template>
    <v-card min-width="300" class="gr-usermenu__card">
      <v-list>
        <v-list-item
          :prepend-avatar="$auth.user.avatarUrl || '/assets/images/avatar.png'"
          :subtitle="
            $auth.isSuperAdmin
              ? `Superadmin`
              : `Relawan (${$auth.user.verifiedStatus !== 'VERIFIED' ? 'Belum' : 'Sudah'} terverifikasi)`
          "
          :title="$auth.user.name"
        />
      </v-list>
      <v-divider />
      <template v-if="$auth.isSuperAdmin">
        <v-list>
          <v-list-item to="/dashboard/admin/users" prepend-icon="mdi-account">
            <v-list-item-title>Kelola Pengguna</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/dashboard/admin/activities"
            prepend-icon="mdi-calendar-edit"
          >
            <v-list-item-title>Kelola aktivitas</v-list-item-title>
          </v-list-item>
          <!-- Both of these were only reachable from the dashboard sidebar, so
               getting to them from anywhere on the public site meant going to
               the dashboard first and finding them there. -->
          <v-list-item
            to="/dashboard/admin/documentations"
            prepend-icon="mdi-image-multiple-outline"
          >
            <v-list-item-title>Kelola dokumentasi</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/dashboard/admin/banners"
            prepend-icon="mdi-image-area"
          >
            <v-list-item-title>Kelola banner</v-list-item-title>
          </v-list-item>
        </v-list>
      </template>
      <template v-else>
        <v-list>
          <v-list-item to="/dashboard/profile" prepend-icon="mdi-account">
            <v-list-item-title>Profil</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/dashboard/my-activities"
            prepend-icon="mdi-calendar-check"
          >
            <v-list-item-title>Aktivitas saya</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/dashboard/activities"
            prepend-icon="mdi-calendar-edit"
          >
            <v-list-item-title>Kelola aktivitas</v-list-item-title>
          </v-list-item>
        </v-list>
      </template>
      <v-divider />
      <v-list>
        <v-list-item prepend-icon="mdi-logout" @click="$emit('logout')">
          <v-list-item-title>Keluar</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script setup lang="ts">
const { $auth } = useNuxtApp();

defineEmits(["logout"]);

const menu = ref(false);
</script>

<style scoped>
.gr-usermenu__trigger {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: none;
  border-radius: 9999px;
  background: transparent;
  cursor: pointer;
}

.gr-usermenu__avatar {
  width: 36px;
  height: 36px;
  border: 1px solid var(--gr-line);
  border-radius: 9999px;
  object-fit: cover;
}
</style>
